/* @flow */
// Example file - fill values with your local changes and rename this file to
// localConfig.js to enable it.
export default {
  googleAnalyticsId: 'UA-XXXXXXX-X',
  port: process.env.PORT || 3000,
  url: 'http://localhost:3000',
  useMailtrap: true,
  mailgun: {
    api_key: 'key-xxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
    domain: 'YOURDOMAIN',
  },
  mailtrap: {
    host: 'mailtrap.io',
    port: 2525,
    auth: {
      user: 'YOUR_USER',
      pass: 'YOUR_PASSWORD',
    },
  },
  emails: {
    system: 'system@yourdomain',
  },
  jwt: {
    secret: 'YOUR_JWT_SECRET',
    algorithm: 'HS512',
  },
  remoteHotReload: false,
  // Enable hot reload on remote device. Note it prevents offline testing,
  // because it depends on ip.address(), which doesn't work with disabled wifi.
  // How do we access a website running on localhost from mobile browser?
  // stackoverflow.com/questions/3132105
  sentryUrl: 'https://YOURSENTRY@app.getsentry.com/77415',
  dbUrl: process.env.MONGO_URI || 'mongodb://127.0.0.1:27017/?directConnection=true&serverSelectionTimeoutMS=2000&appName=mongosh+2.2.5', //'mongodb+srv://minho:MongoVobo123456@cluster0.ul7iy.mongodb.net/?retryWrites=true&w=majority&appName=Cluster0',
}



// WEBPACK FOOTER //
// ./src/server/localConfig.js